module.exports = __webpack_public_path__ + "img/Logo.b9438f2d.svg";